import React from 'react';
import { badges } from '../../data/collectibles';
import { foxCutout } from '../../lib/brandAssets';
import { Sparkle } from '../Sparkle';
const shelves = [badges.slice(0, 3), badges.slice(3, 6)];
export function BadgeShelf() {
  return <section aria-labelledby="badges-heading" className="overflow-hidden bg-lavender py-20 md:py-24" data-id="element-23" data-mp="2ngu6d4b7yzq0">
      <div className="mx-auto max-w-content px-5 sm:px-6" data-id="element-24" data-mp="2jgjrf25g8yz0">
        <div className="flex items-end justify-between gap-6" data-id="element-25" data-mp="3g598wrd5zpkg">
          <div className="max-w-xl" data-id="element-26" data-mp="3g6u48j7azcjd">
            <h2 id="badges-heading" className="font-display text-[32px] leading-tight tracking-tight text-ink md:text-[42px]" data-id="element-27" data-mp="3b5mx8mczihdr">
              A little discovery. A badge to keep.
            </h2>
            <p className="mt-4 text-[18px] text-ink/85" data-id="element-28" data-mp="32eea67wdqoul">
              Each completed adventure earns its own named badge. Take a break whenever you like; nothing is lost
              while you are away.
            </p>
          </div>
          <div className="relative hidden shrink-0 sm:block" data-id="element-29" data-mp="3u37jrmsa13v7">
            <Sparkle className="absolute -left-6 top-2 h-6 w-6" drift={9} data-id="element-30" data-mp="mwp4h3eblfqo" />
            <img src={foxCutout.src} alt="" loading="lazy" decoding="async" width={foxCutout.width} height={foxCutout.height} className="w-[150px] object-contain md:w-[180px]" data-id="element-31" data-mp="rvsc8vloq02c" />
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-12 lg:flex-row lg:gap-6" data-id="element-32" data-mp="45xxg8ht21fg">
          {shelves.map((shelf, s) => <div key={s} className="flex-1" data-id="element-33" data-mp="96lnory7me8m" data-mpi={s}>
              <ul className="grid grid-cols-3 gap-3 px-2 sm:gap-5 sm:px-4" data-id="element-34" data-mp="937mvo572d3a">
                {shelf.map(badge => <li key={badge.name} className="flex flex-col items-center text-center" data-id="element-35" data-mp="3vcilrkgh6v8s">
                    <div className="w-full p-0.5 sm:p-1" data-id="element-36" data-mp="1omb1k3fr1gxd">
                      <img src={badge.src} alt={badge.alt} loading="lazy" decoding="async" width={badge.width} height={badge.height} className="aspect-square w-full object-contain" data-id="element-37" data-mp="1omu86nzy8iw3" />
                    </div>
                    <p className="mt-2.5 min-h-[2.5em] font-display text-[15px] leading-tight text-ink sm:text-[18px]" data-id="element-38" data-mp="1i6kmap0qt0q9">{badge.name}</p>
                  </li>)}
              </ul>
              <div aria-hidden="true" className="mt-4 h-4 rounded-full border-2 border-ink bg-sun shadow-chunky-sm" data-id="element-39" data-mp="2atewmt3uijq0" />
            </div>)}
        </div>
      </div>
    </section>;
}